export default "__VITE_ASSET__C6s9ZZ4j__"